(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-topbar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('.header-topbar-section');
    if (!section) return;

    const content = section.querySelector('.header-topbar__content');
    const track = content ? content.querySelector('.header-topbar__content-track') : null;
    if (!content || !track) return;

    const switcher = section.querySelector('.header-topbar__lang-switcher');
    const originalCount = track.children.length;
    if (!originalCount) return;

    const enableMarquee = () => {
      if (track.children.length === originalCount) {
        const clones = [];
        for (const item of Array.from(track.children).slice(0, originalCount)) {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clones.push(clone);
        }
        for (const clone of clones) {
          track.append(clone);
        }
      }

      const fullWidth = track.scrollWidth;
      const distance = fullWidth / 2;
      const duration = Math.max(12, distance / 45);

      content.style.setProperty('--header-topbar-marquee-distance', distance + 'px');
      content.style.setProperty('--header-topbar-marquee-duration', duration + 's');
      content.classList.add('header-topbar__content--marquee');
    };

    const disableMarquee = () => {
      while (track.children.length > originalCount) {
        track.lastElementChild.remove();
      }
      content.classList.remove('header-topbar__content--marquee');
      content.style.removeProperty('--header-topbar-marquee-distance');
      content.style.removeProperty('--header-topbar-marquee-duration');
    };

    const updateMarqueeState = () => {
      disableMarquee();

      const switcherWidth = switcher ? switcher.offsetWidth : 0;
      const availableWidth = section.clientWidth - switcherWidth - 24;
      const needsMarquee = track.scrollWidth > availableWidth;

      if (needsMarquee) {
        enableMarquee();
      }
    };

    updateMarqueeState();
    window.addEventListener('resize', updateMarqueeState);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
const desktopMenuItems = document.querySelector('.header-menu__items');

if (desktopMenuItems) {
  const navLinks = desktopMenuItems.querySelectorAll('.header-menu__menus a[data-nav-index]');
  const dropdownPanels = desktopMenuItems.querySelectorAll(
    ':scope > .header-menu__dropdown > .header-menu__dropdown-inner > .header-menu__dropdown-panel[data-nav-index]'
  );

  const hideAllDropdowns = () => {
    for (const panel of dropdownPanels) {
      panel.hidden = true;
    }
  };

  const showDropdown = (index) => {
    hideAllDropdowns();
    const panel = desktopMenuItems.querySelector(
      `:scope > .header-menu__dropdown > .header-menu__dropdown-inner > .header-menu__dropdown-panel[data-nav-index="${index}"]`
    );
    if (panel) {
      panel.hidden = false;
    }
  };

  for (const link of navLinks) {
    link.addEventListener('mouseenter', () => {
      const idx = link.getAttribute('data-nav-index');
      if (
        desktopMenuItems.querySelector(
          `:scope > .header-menu__dropdown > .header-menu__dropdown-inner > .header-menu__dropdown-panel[data-nav-index="${idx}"]`
        )
      ) {
        showDropdown(idx);
      } else {
        hideAllDropdowns();
      }
    });
  }

  desktopMenuItems.addEventListener('mouseleave', hideAllDropdowns);
}

const menuButton = document.querySelector('.header-mobile__button:not(.header-mobile__button--back)');
const menuItems = document.querySelector('.header-mobile__menu-items');
const backButton = document.querySelector('.header-mobile__button--back');

if (!menuButton || !menuItems) return;

// Submenu functionality
const submenuButtons = document.querySelectorAll('.header-mobile__menu-item--has-submenu');
const submenuContainers = document.querySelectorAll('.header-mobile__menu-item-submenu');

const menuTextOpen = menuButton.dataset.labelOpen || 'Menu';
const menuTextClose = menuButton.dataset.labelClose || 'Close';

const updateBackButtonVisibility = () => {
  const hasOpenSubmenu = Array.from(submenuContainers).some(submenu => !submenu.hidden);
  if (backButton) {
    backButton.hidden = !hasOpenSubmenu;
  }
};

const toggleMenu = () => {
  // Check if any submenu is open
  const hasOpenSubmenu = Array.from(submenuContainers).some(submenu => !submenu.hidden);
  
  if (hasOpenSubmenu) {
    // Close all submenus
    for (const submenu of submenuContainers) {
      submenu.hidden = true;
    }
    for (const button of submenuButtons) {
      button.setAttribute('aria-expanded', 'false');
    }
    // Keep main menu closed
    menuItems.hidden = true;
    menuButton.setAttribute('aria-expanded', 'false');
    menuButton.textContent = menuTextOpen;
    updateBackButtonVisibility();
    return;
  }
  
  // Toggle main menu
  menuItems.hidden = !menuItems.hidden;
  const isOpen = !menuItems.hidden;
  
  menuButton.setAttribute('aria-expanded', isOpen);
  menuButton.textContent = isOpen ? menuTextClose : menuTextOpen;
  
  if (!isOpen) {
    // Close all submenus when main menu closes
    for (const submenu of submenuContainers) {
      submenu.hidden = true;
    }
    for (const button of submenuButtons) {
      button.setAttribute('aria-expanded', 'false');
    }
  }
  updateBackButtonVisibility();
};

menuButton.addEventListener('click', toggleMenu);

const handleBackButton = () => {
  // Close all submenus
  for (const submenu of submenuContainers) {
    submenu.hidden = true;
  }
  for (const button of submenuButtons) {
    button.setAttribute('aria-expanded', 'false');
  }
  // Show main menu
  menuItems.hidden = false;
  menuButton.setAttribute('aria-expanded', 'true');
  menuButton.textContent = menuTextClose;
  updateBackButtonVisibility();
};

if (backButton) {
  backButton.addEventListener('click', handleBackButton);
}

// Initialize back button visibility
updateBackButtonVisibility();

if (submenuButtons.length !== submenuContainers.length) return;

for (const [index, button] of submenuButtons.entries()) {
  const submenu = submenuContainers[index];
  if (!submenu) continue;

  const toggleSubmenu = () => {
    submenu.hidden = !submenu.hidden;
    const isOpen = !submenu.hidden;
    button.setAttribute('aria-expanded', isOpen);
    
    if (isOpen) {
      menuItems.hidden = true;
    }
    updateBackButtonVisibility();
  };

  button.addEventListener('click', toggleSubmenu);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-homepage"] && !Shopify.designMode) return;
  try {
    
(function() {
  const reviewsContainer = document.querySelector('.hero-homepage-section__reviews');
  if (!reviewsContainer) return;

  const track = reviewsContainer.querySelector('.hero-homepage-section__reviews-track');
  const reviewItems = reviewsContainer.querySelectorAll('.hero-homepage-section__review-item');
  const prevButton = reviewsContainer.querySelector('.hero-homepage-section__reviews-button--prev');
  const nextButton = reviewsContainer.querySelector('.hero-homepage-section__reviews-button--next');

  if (!track || reviewItems.length === 0) return;

  let currentIndex = 0;
  const totalReviews = reviewItems.length;

  function updateSlider() {
    const translateX = -currentIndex * 100;
    track.style.transform = `translateX(${translateX}%)`;
    
    // Update button states
    if (prevButton) {
      prevButton.disabled = currentIndex === 0;
      prevButton.setAttribute('aria-disabled', currentIndex === 0);
    }
    if (nextButton) {
      nextButton.disabled = currentIndex === totalReviews - 1;
      nextButton.setAttribute('aria-disabled', currentIndex === totalReviews - 1);
    }
  }

  function goToNext() {
    if (currentIndex < totalReviews - 1) {
      currentIndex++;
      updateSlider();
    }
  }

  function goToPrev() {
    if (currentIndex > 0) {
      currentIndex--;
      updateSlider();
    }
  }

  if (prevButton) {
    prevButton.addEventListener('click', goToPrev);
  }

  if (nextButton) {
    nextButton.addEventListener('click', goToNext);
  }

  // Initialize
  updateSlider();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  (function () {
    const section = document.querySelector('blog-posts-list');
    if (!section) return;

    const readMoreButton = section.querySelector('[data-blog-posts-read-more]');
    if (!readMoreButton) return;
    const readMoreWrapper = readMoreButton.closest('.blog-posts-read-more');
    if (!readMoreWrapper) return;

    const hasHiddenItems = () => section.querySelector('.blog-post-item--hidden');
    if (!hasHiddenItems()) {
      readMoreWrapper.remove();
      return;
    }

    readMoreButton.addEventListener('click', function () {
      const hiddenItems = section.querySelectorAll('.blog-post-item--hidden');
      for (const item of hiddenItems) {
        item.classList.remove('blog-post-item--hidden');
      }
      if (!hasHiddenItems()) {
        readMoreWrapper.remove();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('.recipe-banner-section');
    if (!section) return;

    const tabs = Array.from(section.querySelectorAll('.recipe-banner__tab'));
    if (!tabs.length) return;

    const buttonContainer = section.querySelector('.recipe-banner__button-container');
    const tabCounter = buttonContainer?.querySelector('.recipe-banner__tab-counter');
    if (!buttonContainer) return;

    const controls = buttonContainer.querySelectorAll('a, button');
    const previousButton = controls[0];
    const nextButton = controls[1];
    if (!previousButton || !nextButton) return;

    let activeIndex = 0;

    function setButtonDisabled(button, disabled) {
      if (button.tagName === 'BUTTON') {
        button.disabled = disabled;
      } else {
        button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        button.tabIndex = disabled ? -1 : 0;
      }
    }

    function updateTabCounter(activeIndex) {
      if (tabCounter) {
        const current = String(activeIndex + 1).padStart(2, '0');
        const total = String(tabs.length).padStart(2, '0');
        tabCounter.textContent = `${current} / ${total}`;
      }
    }

    function updateButtons(index) {
      setButtonDisabled(previousButton, index === 0);
      setButtonDisabled(nextButton, index === tabs.length - 1);
    }

    function setActiveTab(index) {
      activeIndex = index;

      for (const tab of tabs) {
        tab.classList.remove('recipe-banner__tab--active');
      }

      tabs[index].classList.add('recipe-banner__tab--active');
      updateTabCounter(index);
      updateButtons(index);
    }

    setActiveTab(0);

    previousButton.addEventListener('click', function (event) {
      event.preventDefault();
      if (activeIndex === 0) return;
      setActiveTab(activeIndex - 1);
    });

    nextButton.addEventListener('click', function (event) {
      event.preventDefault();
      if (activeIndex >= tabs.length - 1) return;
      setActiveTab(activeIndex + 1);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-overview"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('.recipe-overview-section');
    if (!section) return;

    const readMoreButton = document.querySelector('[data-recipe-overview-read-more]');
    if (!readMoreButton) return;
    const readMoreWrapper = readMoreButton.closest('.recipe-overview-read-more');
    if (!readMoreWrapper) return;

    const hasHiddenItems = () => section.querySelector('.recipe-overview__item--hidden');
    if (!hasHiddenItems()) {
      readMoreWrapper.remove();
      return;
    }

    readMoreButton.addEventListener('click', function () {
      const hiddenItems = section.querySelectorAll('.recipe-overview__item--hidden');
      for (const item of hiddenItems) {
        item.classList.remove('recipe-overview__item--hidden');
      }
      if (!hasHiddenItems()) {
        readMoreWrapper.remove();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-overview"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('.section-reviews-overview');
    if (!section) return;

    const dialogComponent = section.querySelector('dialog-component.review-dialog');
    const dialogContent = section.querySelector('[data-review-dialog-content]');

    const openReviewDialog = (wrapper) => {
      if (!dialogComponent || !dialogContent || !wrapper) return;

      const template = wrapper.querySelector('.review-item__template');
      if (!template) return;

      dialogContent.innerHTML = template.innerHTML;
      dialogComponent.showDialog();
    };

    function openDialogFromHash() {
      const hash = window.location.hash;
      if (!hash || hash.length < 2) return;

      let target;
      try {
        target = section.querySelector(hash);
      } catch (error) {
        return;
      }
      if (!target || !target.classList.contains('review-item-wrapper')) return;

      if (target.classList.contains('review-item--hidden')) {
        const hiddenItems = section.querySelectorAll('.review-item--hidden');
        for (const item of hiddenItems) {
          item.classList.remove('review-item--hidden');
        }
        const readMoreWrapper = section.querySelector('.reviews-overview-read-more');
        readMoreWrapper?.remove();
      }

      target.scrollIntoView();
      openReviewDialog(target);
    }

    openDialogFromHash();
    window.addEventListener('hashchange', openDialogFromHash);

    if (dialogComponent && dialogContent) {
      section.addEventListener('click', function (event) {
        const reviewButton = event.target.closest('.review-item-wrapper:not(.review-item--hidden) .review-item');
        if (!reviewButton) return;

        openReviewDialog(reviewButton.closest('.review-item-wrapper'));
      });
    }

    const readMoreButton = section.querySelector('[data-reviews-read-more]');
    if (!readMoreButton) return;
    const readMoreWrapper = readMoreButton.closest('.reviews-overview-read-more');
    if (!readMoreWrapper) return;

    const hasHiddenItems = () => section.querySelector('.review-item--hidden');
    if (!hasHiddenItems()) {
      readMoreWrapper.remove();
      return;
    }

    readMoreButton.addEventListener('click', function () {
      const hiddenItems = section.querySelectorAll('.review-item--hidden');
      for (const item of hiddenItems) {
        item.classList.remove('review-item--hidden');
      }
      if (!hasHiddenItems()) {
        readMoreWrapper.remove();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steps"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const stepsContainer = document.querySelector('.section-steps');
    if (!stepsContainer) return;

    const steps = Array.from(stepsContainer.querySelectorAll('.step'));
    if (!steps.length) return;
    const stepImages = Array.from(stepsContainer.querySelectorAll('.steps-image__item'));

    const updateActiveImage = (activeStep) => {
      if (!stepImages.length || !activeStep) return;
      const activeStepId = activeStep.getAttribute('data-step-id');
      if (!activeStepId) return;
      const nextImage = stepImages.find((image) => image.getAttribute('data-step-image-id') === activeStepId);
      if (!nextImage) return;

      const currentImage = stepImages.find((image) => image.classList.contains('is-active'));
      const currentImageKey = currentImage ? currentImage.getAttribute('data-step-image-key') : null;
      const nextImageKey = nextImage.getAttribute('data-step-image-key');

      if (currentImageKey && nextImageKey && currentImageKey === nextImageKey) return;

      for (const image of stepImages) {
        const isActive = image.getAttribute('data-step-image-id') === activeStepId;
        image.classList.toggle('is-active', isActive);
      }
    };

    let activeStep = steps.find((step) => step.open);
    if (!activeStep) {
      activeStep = steps[0];
      activeStep.open = true;
    }
    updateActiveImage(activeStep);
    
    steps.forEach((step) => {
      step.addEventListener('toggle', function() {
        if (this.open) {
          // Close all other steps
          steps.forEach((otherStep) => {
            if (otherStep !== this && otherStep.open) {
              otherStep.open = false;
            }
          });
          updateActiveImage(this);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
